import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import ActivityLogs from "../pages/ExamControllerAssistant/ActivityLogs/ActivityLogs";
import CertificateActivityLogs from "../pages/ExamControllerAssistant/Certificate/CertificateActivityLogs/CertificateActivityLogs";
import CertificateList from "../pages/ExamControllerAssistant/Certificate/CertificateList/CertificateList";
import PreviewCertificate from "../pages/ExamControllerAssistant/Certificate/PreviewCertificate/PreviewCertificate";
import ViewCertificate from "../pages/ExamControllerAssistant/Certificate/ViewCertificate/ViewCertificate";
import Dashboard from "../pages/ExamControllerAssistant/Dashboard/Dashboard";
import Profile from "../pages/ExamControllerAssistant/Profile/Profile";
import UserActivityLogs from "../pages/ExamControllerAssistant/Profile/UserActivityLogs/UserActivityLogs";

var ExamControllerAssistantRoutes = [
    {
    path: "dashboard",
    name: "Dashboard",
    element: <Dashboard/>,
    layout: "auditor",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates",
    name: "Certificates",
    element: <CertificateList/>,
    layout: "auditor",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "activity-logs",
    name: "Activity Logs",
    element: <ActivityLogs/>,
    layout: "auditor",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/activity-logs/:certificate_id",
    name: "Certificate Activity Logs",
    element: <CertificateActivityLogs/>,
    layout: "auditor",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "view-certificate",
    name: "View Certificate",
    element: <ViewCertificate/>,
    layout: "auditor",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/preview-certificate/:certificate_id",
    name: "Preview Certificate",
    element: <PreviewCertificate/>,
    layout: "auditor",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "my-profile",
    name: "My Profile",
    element: <Profile/>,
    layout: "auditor",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "my-activities",
    name: "Activity Logs",
    element: <UserActivityLogs/>,
    layout: "auditor",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default ExamControllerAssistantRoutes;
